import { render, staticRenderFns } from "./MizodiaBirthFlowerBouquet.vue?vue&type=template&id=eb18a1e8&"
import script from "./MizodiaBirthFlowerBouquet.vue?vue&type=script&lang=js&"
export * from "./MizodiaBirthFlowerBouquet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports